import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import ITreatmentsRanking from '../../_interfaces/responses/ITreatmentsRanking';
import ITreatmentsMonthlyRanking from '../../_interfaces/responses/ITreatmentsMonthlyRanking';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  constructor(private http: HttpClient) {}

  treatment_monthlyFrequency(
    customers_id: number,
    sites_id: number,
    treatments_id: number,
    year: number,
  ) {
    return this.http.get(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/treatments/${treatments_id}/monthlyFrequency`,
      {
        params: { year },
      },
    );
  }

  treatment_ageGroupsFrequency(
    customers_id: number,
    sites_id: number,
    treatments_id: number,
    year: number,
  ) {
    return this.http.get(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/treatments/${treatments_id}/ageGroupsFrequency`,
      {
        params: { year },
      },
    );
  }

  treatments_ranking(
    customers_id: number,
    sites_id: number,
    startDate?: string,
    endDate?: string,
  ): Observable<ITreatmentsRanking> {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return this.http.get<ITreatmentsRanking>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/treatments/ranking`,
      { params },
    );
  }

  treatments_monthly_ranking(
    customers_id: number,
    sites_id: number,
  ): Observable<ITreatmentsMonthlyRanking[]> {
    return this.http.get<ITreatmentsMonthlyRanking[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/treatments/monthly_ranking`,
    );
  }

  // Patients

  patients_count_appointments(
    customers_id: number,
    sites_id: number,
    startDate?: string,
    endDate?: string,
  ) {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return this.http.get(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/patients/count_appointments`,
      { params },
    );
  }

  patients_count_treatments(customers_id: number, sites_id: number) {
    return this.http.get(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/patients/count_treatments`,
    );
  }

  patients_acquired_weekly(customers_id: number, sites_id: number) {
    return this.http.get(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/statistics/patients/acquired_weekly`,
    );
  }
}
